import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FunnelsModelMC from '../models/FunnelsModelMC';
import {
  fetchFunnelsRequest,
  fetchFunnelsSuccess,
  fetchFunnelsFailure
} from '../../actions/funnelActions';

export const useFunnels = (shouldFetch = false) => {
  const dispatch = useDispatch();
  const { funnels, loading, error } = useSelector((state) => state.funnelsReducer);

  const fetchFromApi = useCallback(async () => {
    try {
      dispatch(fetchFunnelsRequest());
      const response = await FunnelsModelMC.get();
      dispatch(fetchFunnelsSuccess(response?.funnels));
    } catch (err) {
      dispatch(fetchFunnelsFailure(err));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!shouldFetch) return;

    fetchFromApi();
  }, [shouldFetch, fetchFromApi]);

  const funnelOptions = useMemo(() => {
    if (!Array.isArray(funnels)) return [];
    return funnels.map((funnel) => ({
      ...funnel,
      label: funnel.name,
      funnel_steps: funnel.funnel_steps?.map((step) => ({
        ...step,
        label: step.name
      })) || []
    }));
  }, [funnels]);

  return {
    funnels, funnelOptions, loading, error
  };
};

export default useFunnels;
